<form>
    <app-form-section [formGroup]="inventoryForm">
        <app-form-row-header [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_INVENTORY' | translate" icon="inventory_2" />
        <div class="form">
            <app-form-row>
                <app-form-group>
                    <label for="user"
                        >{{ 'FEATURES.AGREEMENTS.USER' | translate }}
                        <span
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.USER' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                    </label>
                    <app-listtype-select
                        formControlName="user"
                        listType="INVENTORY_USERS"
                        [showPotentialValidationMessages]="true"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="location">{{ 'FEATURES.AGREEMENTS.LOCATION' | translate }}</label>
                    <app-listtype-select
                        formControlName="location"
                        listType="LOCATION"
                        [showPotentialValidationMessages]="true"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="typeOfInventory"
                        >{{ 'FEATURES.AGREEMENTS.TYPE_OF_INVENTORY' | translate }}
                        <span
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.TYPE_OF_INVENTORY' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                    </label>
                    <app-listtype-select
                        formControlName="typeOfInventory"
                        listType="TYPE_OF_INVENTORY"
                        [showPotentialValidationMessages]="true"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="inventoryNumber">{{ 'FEATURES.AGREEMENTS.INVENTORY_NUMBER' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="inventoryNumber"
                        formControlName="inventoryNumber"
                        type="text"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="manufacturer">{{ 'FEATURES.AGREEMENTS.MANUFACTURER' | translate }}</label>
                    <app-listtype-select
                        formControlName="manufacturer"
                        listType="MANUFACTURER"
                        [showPotentialValidationMessages]="true"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="model">{{ 'FEATURES.AGREEMENTS.MODEL' | translate }}</label>
                    <app-listtype-select
                        formControlName="model"
                        listType="MODEL"
                        [showPotentialValidationMessages]="true"
                    />
                </app-form-group>
            </app-form-row>

            <app-form-row>
                <app-form-group>
                    <label for="modelYear">{{ 'FEATURES.AGREEMENTS.YEAR' | translate }}</label>
                    <app-dropdown [items]="modelYears" formControlName="modelYear" />
                </app-form-group>
                <app-form-group>
                    <label for="serialNumber">{{ 'FEATURES.AGREEMENTS.SERIAL_NUMBER' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="serialNumber"
                        formControlName="serialNumber"
                        type="text"
                    />
                </app-form-group>
            </app-form-row>

            <app-form-row>
                <app-form-group>
                    <label for="purchaseCost">{{ 'FEATURES.AGREEMENTS.PURCHASE_COST' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="purchaseCost"
                        formControlName="purchaseCost"
                        type="number"
                        min="0"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="benefitValue">{{ 'FEATURES.AGREEMENTS.BENEFIT_VALUE' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="benefitValue"
                        formControlName="benefitValue"
                        type="number"
                        min="0"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="condition"
                        >{{ 'FEATURES.AGREEMENTS.CONDITION' | translate }}
                        <span
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.CONDITION' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                    </label>
                    <app-checkbox
                        [text]="'FEATURES.AGREEMENTS.CONDITION_NEW' | translate"
                        formControlName="condition"
                    />
                </app-form-group>

                <app-form-group>
                    <label for="warranty"
                        >{{ 'FEATURES.AGREEMENTS.WARRANTY' | translate }}
                        <span
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.WARRANTY' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                    </label>
                    <app-checkbox [text]="'FEATURES.AGREEMENTS.WARRANTY_YES' | translate" formControlName="warranty" />
                </app-form-group>
            </app-form-row>
        </div>
    </app-form-section>
</form>
